import { render, staticRenderFns } from "./HistoricoAgendamentos.vue?vue&type=template&id=51eef458"
import script from "./HistoricoAgendamentos.vue?vue&type=script&lang=js"
export * from "./HistoricoAgendamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports